import {connect} from "redux-vue";
import {getScreenSize} from "../../helpers/screens";
import SimulationLink from "./SimulationLink";
import {WEEKS_TARGET} from "../helpers/consts";
import {limit} from "../helpers/tools";

const SimulationProgress = {
  props: ['actions', 'locations'],

  computed: {

    /**
     *
     * @returns {*}
     */
    weeksProgress() {
      const progress = this.actions.history
        .reduce((a, b) => a + b.weeks_required, 1);
      return limit(progress, 0, WEEKS_TARGET);
    },

    /**
     *
     * @returns {number}
     */
    adoptionProgress() {
      const totalAdoption = this.locations.collection
        .reduce((sum, next) => sum + next.adoption, 0);
      const locationsCount = this.locations.collection.length;
      return totalAdoption > 0 ? Math.floor(totalAdoption / locationsCount) : 0;
    },

    /**
     *
     * @returns {*[]}
     */
    progressBarsConfig() {
      return [
        {
          domSelector: '#progress-weeks',
          textValue: this.weeksProgress,
          progressValue: this.weeksProgress / WEEKS_TARGET,
          strokeColor: '#3BCD56',
        },
        {
          domSelector: '#progress-adoption',
          textValue: this.adoptionProgress,
          progressValue: this.adoptionProgress / 100,
          strokeColor: '#FFC000',
        },
      ];
    }
  },

  mounted() {
    const strokeWidth = 10;

    this.bars = [];

    this.progressBarsConfig.forEach((x) => {
      const bar = new ProgressBar.Circle(x.domSelector, {
        trailWidth: strokeWidth,
        easing: 'easeInOut',
        duration: 1400,
        from: { color: x.strokeColor, width: strokeWidth },
        to: { color: x.strokeColor, width: strokeWidth },
        step: function(state, circle) {
          circle.path.setAttribute('stroke', state.color);
          circle.path.setAttribute('stroke-width', state.width);
          circle.setText(x.textValue);
        }
      });
      bar.text.style.fontFamily = '"SofiaPro", Helvetica, sans-serif';
      bar.text.style.fontSize = getScreenSize() === 'sm' ? '1.1rem' : '1.25rem';
      bar.text.style.color = 'white';
      bar.set(x.progressValue);
      this.bars.push(bar);
    });
  },

  watch: {
    weeksProgress() {
      this.updateProgressBars();
    },
    adoptionProgress() {
      this.updateProgressBars();
    }
  },

  methods: {
    updateProgressBars() {
      this.bars.forEach((bar, index) => {
        const config = this.progressBarsConfig[index];
        bar.set( config.progressValue );
        bar.setText( config.textValue );
      });
    },
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <div class="flex flex-col lg:flex-row justify-start lg:items-center text-xs lg:text-sm mb-2 lg:mb-0">
        <div class="flex items-center leading-none text-white">
          <SimulationLink
            to="resources"
            children={(
              <img src="/img/changemanagement/icn-resource.svg" alt="" class="w-5"/>
            )}
            activeClassName="bg-brand-blue-500"
            class="w-10 lg:w-12 h-10 lg:h-12 bg-brand-gray-500 rounded-full mr-1 lg:mr-2 flex items-center justify-center"
          />
          Resource <br/>Documents
        </div>
        <div class="flex items-center leading-none text-white mt-1 lg:mt-0 lg:ml-4">
          <div id="progress-weeks" class="w-10 h-10 lg:w-12 lg:h-12 relative mr-1 lg:mr-2"></div>
          of {WEEKS_TARGET} <br/>WEEKS
        </div>
        <div class="flex items-center leading-none text-white mt-1 lg:mt-0 lg:ml-4">
          <div id="progress-adoption" class="w-10 h-10 lg:w-12 lg:h-12 relative mr-1 lg:mr-2"></div>
          Percent <br/>Adoption
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    actions: state.simulation.actions,
    locations: state.simulation.locations,
  };
}

function mapActionToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapActionToProps)(SimulationProgress);
